<template>
	<article class="itv-breadcrumbs">
		<ul class="itv-breadcrumbs__list">
			<li v-for="(item, i) in getList" :key="i" class="itv-breadcrumbs__item">
				<a v-if="item.value" :href="item.value" class="itv-breadcrumbs__link">
					{{ item.description }}
				</a>
				<span v-else class="itv-breadcrumbs__text">{{ item.description }}</span>
			</li>
		</ul>
	</article>
</template>

<script>
export default {
	name: 'Breadcrumbs',
	props: {
		content: {
			type: Object,
			default: () => {},
		},
	},
	computed: {
		isMobile() {
			return window.innerWidth < 768
		},
		getList() {
			const contentArr = Object.values(this.content)
			return this.isMobile
				? contentArr.slice(contentArr.length - 1, contentArr.length)
				: contentArr
		},
	},
}
</script>
